(function (upp) {
    var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE;

    FreeModuleApiService.$inject = [ '$q', 'appi', 'freeContentAdapterService' ];
    function FreeModuleApiService($q, appi, freeContentAdapterService) {
        Object.defineProperties(this, {
            $q: { value: $q },
            appi: { value: appi },
            cache: { value: new Map() },
            adapter: { value: freeContentAdapterService }
        });
    }

    /**
     * Returns the contents of free module identified by the given moduleId as
     * a trusted HTML that can be rendered on a controller.
     *
     * @return {Promise<string>}
     */
    FreeModuleApiService.prototype.getContents = function(moduleId) {
        var cacheHash = String(moduleId)
        // Check if it is available on the local cahe
        if (this.cache.has(cacheHash))
            return this.$q.when(this.cache.get(cacheHash));
        // Retrieve it from the API
        return this.appi.http.get(URL_API_REST_SERVER + 'free/' + moduleId)
        .then(function (response) {
            return this.adapter.parseContent(response.data.content);
        }.bind(this))
        .then(function (content) {
            this.cache.set(cacheHash, content);
            return content;
        }.bind(this))
    }

    upp.service('freeModuleApiService', FreeModuleApiService);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/free/services/free-module-api.service.js